<script>
  import { onMount, afterUpdate, createEventDispatcher } from "svelte";
  import { link } from "svelte-routing";
  import request from 'superagent';
  
  const LINKS_CONTENT = 1;
  const VIDEO_CONTENT = 2;
  const PAGE_SIZE = 10;
  const defaultItem = { title: "", about: "", videos: [], links: [], comments: [], links_count: 0, videos_count: 0, comments_count: 0, kind: LINKS_CONTENT }
  const dispatch = createEventDispatcher();
  
  export let page = 1;
  export let topic_slug = "";
  export let resource = "news";
  export let url_prefix = "";
  export let api_prefix = "/p" + url_prefix;
  export let additional_query = "";
  export let visible_about = true;
  export let force_video_content = false;
  
  let current_url = "";
  let items = [];
  let offset = 0;
  let count = 0;
  let ttl = 300; // seconds
  let is_loading = false;
  
  window.major.update = function () {
    getNews(true);
  }
  
  afterUpdate(() => {
    getNews();
  });
  
  onMount(() => {
    getNews(true);
  
  })
  
  function getNews(force_refresh) {
    let url = `${api_prefix}/${topic_slug}.json?page=${page}`;
    if (topic_slug == "")
      url = `${api_prefix}/${resource}.json?page=${page}${additional_query}`;
    console.log(url, api_prefix, resource, topic_slug)
    if (!force_refresh) {
      if (url == current_url)
        return
      current_url = url;
      var cache = localStorage.getItem(url);
      if (cache){
        cache = JSON.parse(cache);
        if (parseInt(Date.now() / 1000) - cache.t <= ttl) {
          items = cache.data;
          count = cache.count;
          offset = cache.offset;
          return;
        }
      }
    }
    is_loading = true;
    fetch(url)
      .then(function(r) {
        is_loading = false;
        if (r.ok) return r;
        throw Error(r.statusText);
      })
      .then(r => r.json())
      .then(data => {
        if (data.count > 0) {
          if (!(Array.isArray(data.data) || data.data instanceof Array))
            items = [Object.assign({topic_slug: topic_slug}, defaultItem, data.data)];
          else {
            items = [];
            for (var i in data.data)
              items.push(Object.assign({topic_slug: topic_slug}, defaultItem, data.data[i]));
          }
        } else
          items = [];
        count = data.count;
        page = parseInt(data.page);
        offset = PAGE_SIZE * (page - 1);
        localStorage.setItem(url, JSON.stringify({data: items, count, offset, t: parseInt(Date.now() / 1000)}));
        window.scrollTo(0, 0);
        dispatch('topicOpened', Object.assign({topic_slug, page}));
      })
      .catch(function(error) {
        console.log(JSON.stringify(error));
      });
  }
  
  function changePage(p) {
    if (p <= 0 || p > (count/PAGE_SIZE + 1))
      return;
    page = p;
    getNews();
  }
  
  function onItem(m) {
    dispatch('item', Object.assign({topic_slug: topic_slug}, defaultItem, m));
    return false;
  }
  
  
  export function dragover(ev) {
    ev.preventDefault();
    ev.dataTransfer.dropEffect = 'move';
  }
  
  export function linkFromPost(ev, item_id) {
    ev.preventDefault();
    var post = JSON.parse(ev.dataTransfer.getData("text"));
    var form_id;
    if (post.video_id)
      form_id = window.VIDEO_FORM_ID;
    else
      form_id = window.LINK_FORM_ID;
  
    let call = post.id ? request.put : request.post;
    call(`/form/${form_id}`)
      .send(Object.assign({item_id: item_id}, post))
      .then(resp => {
        for (var i in items) {
          if (item_id == items[i].id) {
            if (post.video_id)
              items[i].videos_count += 1;
            else
              items[i].links_count += 1;
            break;
          }
        }
      })
      .catch(resp => {
        console.log("problem detected when commiting link")
      });
  }
</script>
{#if !items}
<div class='w-25 mx-auto'>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><circle fill="#18289C" stroke="#18289C" stroke-width="15" r="15" cx="40" cy="100"><animate attributeName="opacity" calcMode="spline" dur="2" values="1;0;1;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.4"></animate></circle><circle fill="#18289C" stroke="#18289C" stroke-width="15" r="15" cx="100" cy="100"><animate attributeName="opacity" calcMode="spline" dur="2" values="1;0;1;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.2"></animate></circle><circle fill="#18289C" stroke="#18289C" stroke-width="15" r="15" cx="160" cy="100"><animate attributeName="opacity" calcMode="spline" dur="2" values="1;0;1;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="0"></animate></circle></svg>
</div>
{/if}
<ol class:semi='{is_loading}' class='items-list list-group'>
{#each items as item, i}
<li class='list-group-item border-0 px-1' on:dragover='{dragover}' on:drop='{event => linkFromPost(event, item.id)}'>
{#if force_video_content || item.kind == VIDEO_CONTENT}
<div class='card border-0'>
<h5 class='card-header'>
<a href='{url_prefix}/n/{item.id}' on:click|preventDefault='{() => onItem(item)}' on:keyup|preventDefault='{() => onItem(item)}'>{item.title}</a>
</h5>
<section class='videos d-flex flex-row card-body'>
{#each item.videos as video, i}
<div class='video mx-1' style='width: 178px'>
<a class='d-none d-lg-block' href='{video.uri}' index='{i}' target='_blank'>
<img class='my-1 rounded-lg' src='{video.image}' width='178'>
</a>
<a class='d-block' href='{video.uri}' index='{i}' target='_blank' title='{video.title}'>
<div class='elpsis'>
{video.title}
</div>
</a>
</div>
{/each}
</section>
</div>

{:else}
<article class='d-flex flex-column'>
<h2 class='my-1'>
<a href='{url_prefix}/n/{item.id}' on:click|preventDefault='{() => onItem(item)}' on:keyup|preventDefault='{() => onItem(item)}'>{item.title}</a>
</h2>
<section class='meta text-muted d-flex flex-row text-smlr'>
<span class='d-inline-block mx-1'>
{item.created_at}
</span>
<span class='d-inline-block mx-1'>
<i class='fas fa-external-link-alt'></i>
{item.links_count}
</span>
<span class='d-inline-block mx-1'>
<i class='fas fa-video'></i>
{item.videos_count}
</span>
{#if item.rating}
<span class='d-inline-block mx-1'>
<i class='fa fa-star'></i>
{item.rating}
</span>
{/if}
</section>
{#if item.about && visible_about}
<section class='about'>
{@html item.about}
</section>
{/if}
</article>

{/if}
</li>
{/each}
</ol>
<div class='margin-auto text-center mt-2'>
{offset} - {offset + PAGE_SIZE} ({count})
</div>
<nav class='nav margin-auto text-center d-flex justify-content-around'>
{#if page-1}
<a class='nav-link' href='?page={page-1}' on:click|preventDefault='{() => changePage(page-1)}' on:keyup|preventDefault='{() => changePage(page-1)}' tinro-ignore>
Předchozí strana
</a>
{/if}
{#if items.length && (count - offset > PAGE_SIZE) }
<a class='nav-link' href='?page={page+1}' on:click|preventDefault='{() => changePage(page+1)}' on:keyup|preventDefault='{() => changePage(page+1)}' tinro-ignore>
Další strana
</a>
{/if}
</nav>

